import { Helmet } from "react-helmet-async";

const BRAND = "PretUp";
const DEFAULT_DESCRIPTION =
    "Pretup est une plateforme de prêts en crowdlending entre particuliers et entreprises. Prêtez à des entreprises en croissance en échange d'un rendement allant jusqu'à 11% !";

const isNonEmptyString = (value) => typeof value === "string" && value.trim().length > 0;

const Seo = ({ title, description }) => {
    const fullTitle = isNonEmptyString(title)
        ? title.includes(BRAND)
            ? title
            : `${title} | ${BRAND}`
        : BRAND;

    const metaDescription = isNonEmptyString(description)
        ? description
        : isNonEmptyString(title)
            ? `${title} – ${DEFAULT_DESCRIPTION}`
            : DEFAULT_DESCRIPTION;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={metaDescription} />
        </Helmet>
    );
};

export default Seo;
